import { useRef } from "react";
import FileDownload from "js-file-download";
import { AxiosResponse } from "axios";
import { getFileName } from "../../Utils/GetFileName";
import {
  showActionFailureToast,
  showNotSelfClosingActionStartToast,
  showActionSuccessToast,
  ToastId,
} from "../../TransportNetwork/NotificationForActionButton";
import {
  EXCEL_EXPORT_FAILURE_MESSAGE,
  EXCEL_EXPORT_START_MESSAGE,
  EXCEL_EXPORT_SUCCESS_MESSAGE,
} from "./excelExportMessages";
import { removeQuotationMarksFrom } from "../../Utils/strings";

export function useExportWithToast<T>(
  exportFunction: (urlParams?: T) => Promise<AxiosResponse>,
  message: string
) {
  const toastId: ToastId = useRef(null);
  return async (urlParams?: T) => {
    toastId.current = showNotSelfClosingActionStartToast(message ?? EXCEL_EXPORT_START_MESSAGE);
    try {
      const response = await exportFunction(urlParams);
      const filename = getFileName(response);

      FileDownload(response.data, removeQuotationMarksFrom(filename));
      showActionSuccessToast(toastId, EXCEL_EXPORT_SUCCESS_MESSAGE);
    } catch {
      showActionFailureToast(toastId, EXCEL_EXPORT_FAILURE_MESSAGE);
    }
  };
}
